export const getMessage: any = {
  NUMBER_SENT_FAILURE:"Invalid mobile number",
  OTP_ENTER_FAILURE:"INVALID OTP",
  NUMBER_SENT_SUCCESS:"OTP has been successfully sent to your registered phone number",
  EMAIL_SENT_FAILURE: "Something went wrong",
  EMAIL_SENT_SUCCESS: "Email sent successfully",
  CONSENT_FORM_SUCCESS: "Your request recieved successfully",
  CONSENT_FORM_ERROR: "There is some technical issue",
  REQUEST_EXIST_ERROR:
    " Your request is already in progress. Thank you for contacting.",
  PARTNER_SUCCESSFUL:
    "Thank you for showing interest with us. Your request received and we will connect with you shortly.",
  USER_NOT_EXISTS: "No user found with the given email id ",
  USERNAME_EXIST_ERROR: "Username already exists",
  SERVICEPROVIDER_FEEDBACK_SUCCESS: "Your review has been added successfully",
  CANCELLATION_SUCCESS:
    "Your cancellation request has been recorded successfully. Please check your email.",
  CHECK_IN_SUCCESS: "You checked in successfully!!!",
  CHECK_OUT_SUCCESS: "You checked out successfully!!!",
  CHECK_OUT_PENDING_PAY_SUCCESS:"Checkout successful. Please pay for pending amount if any!!!",
  DETAILS_NOT_FOUND:"Booking Detail not found. Please contact service desk.",
  VEHICLE_ADDED_SUCCESS:"Vehicle added successfully",
  VEHICLE_UPDATED_SUCCESS:"Vehicle updated successfully",
  PAYMENT_FAILURE:"Your payment completed for extra hours but there is some techincal issue. Please contact customer support.",
  PAYMENT_SUCCESS:"Your booking completed successfully. Thank you for using Spotfinder!!!",
  CHECK_OUT_PENDING_AMOUNT:"Checkout successful. Please pay for pending amount if any!!!",
  CHECKED_IN_SUCCESSFYULLY:"Checked in successfully",
  UPDATE_ACCOUNT_SUCCESS:"Your account details updated successfully",
  PROFILE_REMOVE_SUCCESS:"Profile picture removed successfully",
  PROFILE_UPDATE_SUCCESS:"Profile picture updated successfully",
  ERROR_ON_ADDING_PARKING_TO_FAVOURITE:"Could not update favourite parking",
  ADDING_PARKING_TO_FAVOURITE:"Favourite parking updated successfully",
  SERVICEPROVIDER_FORGET_PASSWORD:"Password sent on your registered email",
  CANCELLATION_ERROR:"Cannot cancel your booking. Please try again in some time",
};
